import React from 'react';
import { ThemeOptions, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import AsStandInLabel from '../AsStandInLabel/AsStandInLabel';

const useStyles = (featuredIntermittence: boolean) => makeStyles(({ cartTheme }: ThemeOptions) => ({
  buttonWithIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 10px',
    height: '100%',
    width: '100%',
    '& svg': {
      width: '30px',
      height: '20px',
    },
  },
  buttonWithoutIcon: {
    '&[disabled]': {
      backgroundColor: 'unset',
    },
  },
  featuredButton: {
    backgroundColor: cartTheme.alertWarningBg,
    border: `1px solid ${cartTheme.alertWarning}`,
    animation: featuredIntermittence ? '$buttonIntermittence linear 2000ms infinite' : '',
  },
  '@keyframes buttonIntermittence': {
    '50%': {
      backgroundColor: 'unset',
      border: '1px solid transparent',
    },
    '70%': {
      backgroundColor: `${cartTheme.alertWarningBg}54`,
      border: `1px solid ${cartTheme.alertWarning}54`,
    },
    '30%': {
      backgroundColor: cartTheme.alertWarningBg,
      border: `1px solid ${cartTheme.alertWarning}`,
    },
  },
}));

interface SimpleButtonProps {
  disabled?: boolean;
  color: string;
  buttonText: string;
  handleClick: (ev?: Event) => void;
  id: string;
  textStyle?: string;
  size?: 'small' | 'medium' | 'large';
  featured?: boolean;
  featuredIntermittence?: boolean;
  iconComponent?: React.ReactNode;
  asStandIn?: boolean;
  buttonClassName?: string
}

const SimpleButton: React.FC<SimpleButtonProps> = (props) => {
  const { disabled = false, color, buttonText, handleClick, id, textStyle = '', size = 'medium',
    featured = false, featuredIntermittence = false, iconComponent = null, asStandIn, buttonClassName } = props;
  const classes = useStyles(featuredIntermittence)();

  return (
    <Button
      id={id}
      data-testid={id}
      onClick={handleClick}
      color={color}
      disabled={disabled}
      size={size}
      className={`${featured ? classes.featuredButton : ''} ${iconComponent ? classes.buttonWithIcon : classes.buttonWithoutIcon} ${buttonClassName || ''}`}
      startIcon={iconComponent}
    >
      <strong className={textStyle}>{buttonText}</strong>
      {asStandIn && <AsStandInLabel actionButton />}
    </Button>
  );
};

export default SimpleButton;
